<h1 mat-dialog-title class="dialog-title-container">Additional Information</h1>
<button mat-icon-button class="close-icon" (click)="onClose()" aria-label="Close dialog">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content class="custom-dialog-content">
  <div class="table-container um-table-wrap">
    <table mat-table [dataSource]="dataSource" class="mat-table um-table um-table-dialog">
      <ng-container matColumnDef="key">
        <th class="col-key left-sorted-header" mat-header-cell *matHeaderCellDef>Key</th>
        <td class="col-key left-sorted-header" mat-cell *matCellDef="let element">{{ element.key }}</td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th class="col-value centered-sorted-header" mat-header-cell *matHeaderCellDef>Value</th>
        <td class="col-value centered-sorted-header" mat-cell *matCellDef="let element">
          <ng-template #elseTemplate>
            <a *ngIf="element.key === 'loc'" target="_blank" [href]="'https://www.google.com/maps/place/' + element.value">{{ element.value || '-' }}</a>
            <div *ngIf="element.key !== 'loc'">{{ element.value || '-' }}</div>
          </ng-template>
          <a *ngIf="element.key === 'hdUrl' || element.key === 'eventLink'; else elseTemplate"
            [href]="element.value ? element.value : ''" target="_blank">
            Link
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
